(function () {
    'use strict';

    angular
        .module('app')
        .controller('SetEmailTemplateDialogCtrl', SetEmailTemplateDialogCtrl);

    SetEmailTemplateDialogCtrl.$inject = ['DialogInstance', 'DialogService', 'DocumentTemplatesService', 'email', 'emailTemplates'];

    /**
     * @ngdoc Controller
     * @name SetEmailTemplateDialogCtrl
     *
     * @description
     * Dialog for showing a list of email templates which will retrieve the document template data for the selected email template and then append these to the email.
     *
     * @param {object} email
     * @param {object} emailTemplates - Email templates applicable to the email.
     */
    function SetEmailTemplateDialogCtrl(DialogInstance, DialogService, DocumentTemplatesService, email, emailTemplates) {
        /* jshint validthis:true */
        var vm = this;
        vm.processing = false;
        vm.emailTemplates = angular.copy(emailTemplates);
        vm.hasValueIcon = hasValueIcon;
        vm.unselectEmailTemplates = unselectEmailTemplates;
        vm.convertEmailContactArrayToString = convertEmailContactArrayToString; 
        vm.showDocumentTemplateFile = showDocumentTemplateFile;
        vm.cancel = cancel;
        vm.ok = ok;
        Object.defineProperty(vm, 'emailTemplateSelected', {
            get: function () { return _.some(vm.emailTemplates, function (et) { return et.Selected; }); }
        });

        activate();

        function activate() {
        }

        /*
         * Closes dialog returning the document template data for the selected email template.
         *
         * @param {string} value - Returns an icon depending on wether the supplied value has an actual value (e.g. not null, undefined, empty string).
         *
         * @returns {string} Icon that is to be shown for the values state.
         */
        function hasValueIcon(value) {
            var result = 'unchecked';

            if (!_.isNil(value) && value !== '' && !(angular.isArray(value) && value.length === 0)) {
                result = 'checked';
            }

            return result;
        }

        /*
         * Method called when the checkbox is used for selecting or unselecting an email template. To ensure only one email template can be selected at once, this method
         * deselects all email templates which did not cause the method to be invoked.
         *
         * @param {object} emailTemplate - The email template which was changed.
         */
        function unselectEmailTemplates(emailTemplate) {
            // Unselected all email templates which are not the email template which caused this method to be trigged.
            angular.forEach(vm.emailTemplates, function (et) {
                if (emailTemplate !== et) {
                    et.Selected = false;
                }
            });

            // If the selected email template has changed, the error message is no longer valid.
            delete vm.error;
        }

        /*
         * Convert an array of EmailContact to a user readable string
         *
         * @param {array} emailContactArray - Array of EmailContact objects
         *
         * @returns {string} - Returns the EmailContacts in a single user readable string
         */
        function convertEmailContactArrayToString(emailContactArray) {
            var result = '';

            _.forEach(emailContactArray, function (contact) {
                if (result !== '') {
                    result += ', ';
                }

                var addressValue = (!contact.ReferenceContact && !_.isNil(contact.Value) && contact.Value !== '') ? contact.Value : '';
                if (!_.isNil(contact.Name) && contact.Name !== '') {
                    result += contact.Name + (addressValue !== '' ? (' <' + addressValue + '>') : '');
                } else {
                    result += addressValue;
                }
            });

            return result;
        }

        /*
         * Show the document template file contents in a dialog
         *
         * @param {int} documentTemplateId - Id of the document template which has the file to be shown
         * @param {string} format - Format of the document template file which is to be shown. ('txt' or 'html')
         */
        function showDocumentTemplateFile(documentTemplateId, format) {
            DocumentTemplatesService.getDocumentFile(documentTemplateId)
                .then(getfileOk, getFileError);

            function getfileOk(response) {
                DialogService.show({
                    locals: { fileData: response.data, format: format },
                    controller: 'ViewFileContentsDialog',
                    controllerAs: 'vm',
                    templateUrl: 'app/controls/dialog/view-file-contents-dialog.tmpl.html'
                });
            }

            function getFileError(response) {
                DialogService.error('Error retrieving Document Template file', response);
            }
        }

        /*
         * Populates the email using the seleted email template. If successful the dialog will be closed, otherwise an error will be shown.
         */
        function ok() {
            vm.processing = true;
            delete vm.error;

            var selectedEmailTemplate = _.find(vm.emailTemplates, function (emailTemplate) {
                return emailTemplate.Selected;
            });

            if (!_.isNil(selectedEmailTemplate)) {
                email.setEmailTemplate(selectedEmailTemplate)
                    .then(loadEmailTemplateOk, loadEmailTemplateError);
            } else {
                DialogInstance.ok();
            }

            function loadEmailTemplateOk() {
                DialogInstance.ok();
            }

            function loadEmailTemplateError(response) {
                vm.processing = false;
                vm.error = 'The email template was not successfully loaded. To retry press the "Load" button.';
            }
        }

        /*
         * Closes dialog with a cancelled state.
         */
        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
